<template>
  <v-select
    :items="branches"
    v-model="selectedBranch"
    item-text="name"
    item-value="_id"
    label="Sucursal"
    color="secondary"
    v-on:change="branchChange"
    item-color="indigo darken-1"
    filled
    rounded
  ></v-select>
</template>

<script>
// Importar dependencias
import { mapGetters } from "vuex";

// importar servicios
import BranchesServices from "@/services/BranchesServices";

export default {
  mounted: async function() {
    // Obtener las sucursales
    await this.getBranches();
  },
  data: function() {
    return {
      branches: [],
      selectedBranch: null
    };
  },
  computed: {
    ...mapGetters(["getProfile"])
  },
  methods: {
    getBranches: async function() {
      // Obtener sucursales del usuario
      const branches = await BranchesServices.getBranchesInUserProfile();

      // Verificar si el usuario es un dueño para mostrar la opción de todas las sucursales
      if (this.getProfile.user_type === "owner") {
        // Agregar opción para todas las sucursales
        this.branches.push({ _id: -1, name: "Todas las sucursales" });
      }

      // Agregar sucursales
      this.branches.push(...branches);
      this.selectedBranch = { _id: this.branches[0]._id };

      // Emitir cambio de sucursal
      this.branchChange(this.selectedBranch._id);
    },
    branchChange: function(_id) {
      // Modificar la sucursal seleccionada
      this.selectedBranch = { _id };
      // Obtener los datos de ventas
      this.$emit("branch-selected", _id);
    }
  }
};
</script>

<style scoped></style>
